import { IconName } from '@zenchef/icomoon'
import { Flex } from '@zenchef/styled-system/jsx'
import { Container as BaseContainer, ModalWithoutHeader, Text } from '@zenchef/ui'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

import DoubleCircleIcon from '@/components/ui/DoubleCircleIcon'
import { config } from '@/config'
import { useTranslation } from '@/utils/hooks'
import useSdkEvents from '@/utils/hooks/useSdkEvents'
import safelySetInnerHTML from '@/utils/safelySetInnerHTML'

const Unavailable = observer(() => {
  const { t } = useTranslation()
  const { sendRemoveIframe } = useSdkEvents()

  useEffect(() => {
    sendRemoveIframe()
  }, [sendRemoveIframe])

  return (
    <ModalWithoutHeader noHeader>
      <BaseContainer justifyContent='center' alignItems='center' border='none' bg='white.default'>
        <DoubleCircleIcon mb='10px' icon={config.brandIcon as IconName} smallIcon='alert' />
        <Flex flexDirection='column' px='padding.6'>
          <Text
            letterSpacing='0.5px'
            mb='5px'
            textAlign='center'
            fontSize='xs'
            fontWeight={2}
            color='#2c3037'
            css='text-transform:uppercase;'>
            {t('widget_unavailable')}
          </Text>
          <Text textAlign='center' fontSize='s' color='grey.default'>
            <div {...safelySetInnerHTML(t('widget_unavailable_description'))} />
          </Text>
        </Flex>
      </BaseContainer>
      <style jsx global>
        {`
          body {
            background: white;
          }
          @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
            #modal {
              height: 450px;
            }
          }
        `}
      </style>
    </ModalWithoutHeader>
  )
})

export default Unavailable
